import Vue from 'vue'

const requireComponent = require.context('../components/base', false, /base-[\w-]+\.vue$/)

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '').convertToPascalCase('-')
  Vue.component(componentName, componentConfig.default || componentConfig)
})
